import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Register service worker for offline caching
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
//jfhohfo
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(  
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter> 
);
